export default __webpack_public_path__ + "fonts/angles-left-regular.svg";